var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"omapi-progress-bar"},_vm._l((_vm.total),function(index){return _c('div',{key:index,staticClass:"omapi-progress-bar__step",class:{ 'omapi-progress-bar__step-active': _vm.isActive(index) }})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }